<template>
  <v-stepper alt-labels flat tile elevation="0" class="pt-2">
    <v-stepper-header>
      <v-stepper-step
        style="max-width: 150px"
        v-for="(tab, idx) in tabs"
        :key="tab.title"
        :editable="isNew ? tab.isEditable : true"
        :step="idx + 1"
        :rules="getRules(tab)"
      >
        <v-tooltip v-if="isNew && !tab.isEditable" bottom>
          <template v-slot:activator="{ on, attrs }">
            <p v-bind="attrs" v-on="on" class="text-center">
              {{ tab.title }}
              <small v-if="tab.isOptions">(опционально)</small>
            </p>
          </template>
          <span>{{ tooltipMessages }}</span>
        </v-tooltip>
        <p v-else class="text-center">
          {{ tab.title }}<small v-if="tab.isOptions">(опционально)</small>
        </p>
      </v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content
        v-for="(tab, idx) in tabs"
        :key="tab.title + idx + 1"
        :step="idx + 1"
      >
        <router-view/>
      </v-stepper-content>
      <v-stepper-content
        v-for="(tab, idx) in tabs"
        :key="tab.title + idx"
        :step="idx + 1"
      >
        <slot :name="idx"/>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
export default {
  name: 'HeaderSteppers',
  props: {
    tabs: {
      type: Array,
      required: true,
      default: () => []
    },
    rules: {
      type: Object,
      default: null
    },
    isNew: {
      type: Boolean,
      default: false
    },
    tooltipMessages: {
      type: String,
      default: 'Необходимо создать событие с расписанием!'
    }
  },
  methods: {
    getRules (tab) {
      if (!tab?.requiredFields) {
        return []
      } else {
        const rules = Object.keys(this.rules)?.filter(
          rule => tab?.requiredFields?.includes(rule) || null
        )
        const result = rules.reduce((acc, rule) => {
          acc = this.rules[rule]?.length ? true : acc
          return acc
        }, false)
        return result ? [() => false] : []
      }
    }
  }
}
</script>
